import { z } from "zod";
import { createRefinableSchema } from "../../utility-types/create-refinable-schema.js";
const createTranslatablePropertiesSchema = createRefinableSchema({
    schema: (context)=>z.object({
            id: z.string(),
            language: z.string()
        })
});
var EMachineTranslationStatus = /*#__PURE__*/ function(EMachineTranslationStatus) {
    EMachineTranslationStatus["NoTranslation"] = "no-translation";
    EMachineTranslationStatus["Full"] = "full";
    EMachineTranslationStatus["Partly"] = "partly";
    return EMachineTranslationStatus;
}(EMachineTranslationStatus || {});
export { createTranslatablePropertiesSchema, EMachineTranslationStatus };
